import { useEffect } from "react"
import RecentPost from "../../components/Blog/RecentPost"
import Footer from "../../components/Footer"
import Navbar from "../../components/Home/Navbar"
import ScrollUpButton from "../../components/Widgets/ScrollUpButton"
import { blogNavLinks } from "../../utilities/links"

const BlogHome = () => {
	useEffect(() => {
		document.title = `Blog | SMARTA`
		return () => {
			document.title = "SMARTA | Developmental hub for teenagers that thrive!"
		}
	}, [])

	return (
		<div>
			<Navbar links={blogNavLinks} />
			<section id="home" className="h-[50vh] bg-cover relative bg-center bg-[url('https://images.unsplash.com/photo-1502465771179-51f3535da42c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=869&q=80')]">
				<div className='inset-0 absolute bg-[#161c2dbf] opacity-90'></div>
				<div className='flex h-full flex-col relative'>
					<div className='m-auto max-w-2xl md:max-w-[60rem] pt-20 app-x'>
						<h3 className='font-serif leading-snug text-center font-extrabold text-white text-4xl md:text-5xl'>
							<span className="md:hidden">Latest News Updates and Tips</span>
							<span className="hidden md:inline">Taking control of your daily life is easy when you know how!</span>
						</h3>
					</div>
				</div>
			</section>
			<RecentPost />
			{/* <PostCategory />
			<FeaturedPost />
			<Authors />
			<Subscribe /> */}
			<Footer />
			<ScrollUpButton />
		</div >
	)
}

export default BlogHome